export class ControleAcessoCliente {
  public id: number;
  public idclient: number;
  public data_login: Date;

  constructor() { }
}
